import loadable from '@loadable/component';

export const FlashBarLoadable = loadable(() => import('./FlashBar'), {
  resolveComponent: (module) => module.FlashBar,
});
